/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/input/custom-elements';

import { defineCustomElement as defineOsdsInput } from '@ovhcloud/ods-stencil/components/input/custom-elements/osds-input.js';

export const OsdsInput = /*@__PURE__*/createReactComponent<JSX.OsdsInput, HTMLOsdsInputElement>('osds-input', undefined, undefined, defineOsdsInput);
